import { render, staticRenderFns } from "./AgentSignUpSuccess.vue?vue&type=template&id=0b76f7ca"
import script from "./AgentSignUpSuccess.vue?vue&type=script&lang=js"
export * from "./AgentSignUpSuccess.vue?vue&type=script&lang=js"
import style0 from "./AgentSignUpSuccess.vue?vue&type=style&index=0&id=0b76f7ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCardActions,VCardText,VIcon})
